import src from "IMAGE";
export default { src, width: 1946, height: 919, blurWidth: 0, blurHeight: 0};
